import { render, staticRenderFns } from "./AppsPanel.vue?vue&type=template&id=cb938868"
import script from "./AppsPanel.vue?vue&type=script&lang=js"
export * from "./AppsPanel.vue?vue&type=script&lang=js"
import style0 from "./AppsPanel.vue?vue&type=style&index=0&id=cb938868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports